import type { ExcJaneStreetV1PfofJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../../util/routing/entity-paths';

export const JANE_STREET_PFOF_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/jane-street/pfof/job');

export const getJaneStreetPfofJobPath: EntityPathBuilder<ExcJaneStreetV1PfofJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JANE_STREET_PFOF_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${JANE_STREET_PFOF_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getJaneStreetPfofJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getJaneStreetPfofJobPath({ kind: 'detail', keys: { jobId } });
}
